import { useEffect } from 'react';

type Props = {
  show?: boolean;
};

export function useHideDocumentScroll({ show }: Props = {}) {
  useEffect(() => {
    if (show) return undefined;

    window.document.body.style.overflowY = 'hidden';

    return () => {
      window.document.body.style.overflowY = '';
    };
  }, [show]);
}
